<template>
	<div class="notification-list">
		<Button
			v-if="showHeader"
			icon="x"
			class="transparent circle close-notifications-button"
			@click.native="$emit('close')"
		/>
		<h2 v-if="showHeader && notificationsOrdered.length > 0">Notifications</h2>
		<div class="buttons">
			<Button
				v-if="notificationsOrdered.length > 0"
				class="secondary block"
				icon="eye"
				size="small"
				@click="$store.dispatch('notification/markAllAsRead')"
			>
				Mark all read
			</Button>
			<Button
				v-if="notificationsOrdered.length > 0"
				class="secondary block"
				icon="x"
				size="small"
				@click="$store.dispatch('notification/clearAll')"
			>
				Clear all
			</Button>
		</div>
		<Notification
			v-for="(notification, index) in notificationsOrdered"
			:key="index"
			:notification-id="notification._id"
			:title="notification.title"
			:message="notification.message"
			:image="notification.image"
			:read="notification.read"
			:icon="notification.icon"
			:time="notification.createdAt"
			:link="notification.link"
		/>
		<NoResults
			v-if="notifications.length === 0"
			icon="bell"
			icon-size="x4"
			title="No Notifications"
			message="They'll be here when you get them."
		/>
	</div>
</template>
<script lang="ts">
import Button from '@cv/components/atoms/Button.vue'
import Notification from '@cv/components/molecules/Notification.vue'
import NoResults from '@cv/components/organisms/NoResults.vue'
import Vue from 'vue'

export default Vue.extend({
	components: {
		Button,
		Notification,
		NoResults
	},
	props: {
		notifications: {
			type: Array,
			default: () => []
		},
		showHeader: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		notificationsOrdered() {
			return [...this.notifications].reverse()
		}
	}
})
</script>
<style lang="less" scoped>
@import '../../less/mixins.less';
@import '../../less/variables';

.notification-list {
	border-left: 1px solid lighten(@grayLightMedium, 15%);
	background: @white;
	flex-shrink: 0;
	flex-grow: 0;
	overflow: visible auto;
	user-select: none;
	cursor: default;
	padding: 1em;
	box-sizing: border-box;
}

.blocked {
	text-align: center;
	font-size: 90%;
	color: @grayMedium;
}

.buttons {
	display: flex;
	gap: 0.5em;
	button {
		margin-top: 0;
		margin-bottom: 0.5em;
	}
}

@keyframes overdue {
	0% {
		background-color: #fff;
		color: @black;
	}
	5% {
		background-color: transparent;
		color: @grayLightMedium;
	}
	10% {
		background-color: #fff;
		color: @black;
	}
	15% {
		background-color: transparent;
		color: @grayLightMedium;
	}
	20% {
		background-color: #fff;
		color: @black;
	}
	100% {
		background-color: #fff;
		color: @black;
	}
}

.close-notifications-button {
	float: right;
	vertical-align: middle;
	color: @grayMedium;
	&:hover,
	&:active {
		background: @grayLightMedium;
		color: @grayDark;
	}
}
</style>
